import axiosConfig from "./axiosConfig";

const deleteSolarEdgeAlertAcknowledgement = async (
  authToken: string,
  siteId: string,
  alertId: number
): Promise<void> => {
  await axiosConfig.delete(
    `/site/${siteId}/health/solaredge-alerts/${alertId}/acknowledgement`,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
};

export default deleteSolarEdgeAlertAcknowledgement;
